import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GetAllUnacceptedCustomersService {
  private customerSource = new BehaviorSubject({})
  currentCustomer = this.customerSource.asObservable();

  constructor(private http: HttpClient) { }

  changecustomer(customer){
    this.customerSource.next(customer)
   //console.log(this.customerSource)
  }

  getAllUnapprovedCustomers(){
    return this.http.get(environment.apiBaseUrl+'/moderator/get-all-unapproved-customers')
  }

  approveCustomer(customer){
    return this.http.post<any>(environment.apiBaseUrl+'/moderator/approve-banking-details', customer)
  }

  disapproveCustomer(customer){
    return this.http.post<any>(environment.apiBaseUrl+'/moderator/disapprove-banking-details', customer)
  }
}
